<div id="homepage">
  <div class="home">
    <div class="title">
      {{"Sviluppo"|translate}} <span class="green title_middle">{{"Progettazione"|translate}}</span> {{"Sistemi"|translate}}
    </div>

    <div class="subtitle mt-3">{{"HOMEPAGE_SUB_TITLE"|translate}}</div>
    <div class="text-center mt-5">
      <div class="button button-green">
        <a [href]="getBrochureName()" target="_blank">{{"SCARICA LA BROCHURE"|translate}}</a>
      </div>
    </div>
  </div>
  <!--div class="wrapper pdg-bottom p-top-small">
    <span class="white font-14 text-uppercase item-bord" *ngFor="let item of home">
      {{item.description}}<br>
    </span>
  </div-->


  <who-we-are id="who-we-are"></who-we-are>
  <app-gallery></app-gallery>
  <app-mission-vision id="mission-vision"></app-mission-vision>
  <app-offered-services id="offered-services"></app-offered-services>
  <app-projects-important id="projects-important"></app-projects-important>
  <app-our-customers id="our-customers"></app-our-customers>
  <app-about-us id="about-us"></app-about-us>
  <!-- <app-work-with-us id="work-with-us"></app-work-with-us> -->
  <app-history id="history"></app-history>
  <app-contacts id="contacts"></app-contacts>
</div>